import { RuleDecl } from "vue/types/options";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Affiliates from "./Affiliates";

export const validations: RuleDecl = {
    affiliateName: {
        affiliateRequired: required,
        minAffiliateLength: minLength(4),
        maxAffiliateLength: maxLength(300),
        unique: (value: string, component: Affiliates) => {
            if (!!component) {
                return (component.affiliates?.findIndex(u => u.name.localeCompare(value) === 0) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
    editingAffiliateName: {
        affiliateRequired: required,
        minAffiliateLength: minLength(4),
        maxAffiliateLength: maxLength(300),
        unique: (value: string, component: Affiliates) => {
            if (!!component) {
                return (component.affiliates?.findIndex(u => u.name.localeCompare(value) === 0 &&
                    u.affiliateId !== component.editingAffiliateId) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
};

export const validationMessages = {
    affiliateRequired: "Affiliate is required",
    minAffiliateLength: "Affiliate must have at least {min} letters",
    maxAffiliateLength: "Affiliate must have less than {max} letters",
    unique: "Affiliate must be unique",
};
